import axiosCommon from '@/axios-common/axios-common';
import InfiniteLoading from 'vue-infinite-loading';
import vSelect from 'vue-select';
import {flatpickrConfig,thumbnail} from '../../../config';

export default {
    name: 'guidelineDashboard',
    dependencies:['localeService'],
    components: {
        InfiniteLoading,
        vSelect
    },
    mounted() {
        this.initialize()
    },
    data() {
        return {
            guidelines: [],
            search: {
                dateRange: '',
                fromDate: '',
                toDate: '',
                keywords: []
            },
            flatpickrConfig,
            thumbnail,
            skip: 0,
            take: 5
        }
    },
    methods: {
        initialize() {
            let vm = this;

            return vm.getGuidelines()
                .then(function (res) {
                    if (res.data.length > 0) {
                        vm.guidelines = res.data;
                    }
                })
                .catch(function (err) {
                    console.log(err);
                    return err;
                });
        },
        infiniteHandler($state) {
            let vm = this;
            vm.skip += vm.take;
            vm.getGuidelines()
                .then(function (res) {
                    vm.guidelines = vm.guidelines.concat(res.data);
                    $state.loaded();
                    if (res.data.length == 0) {
                        $state.complete()
                    }
                })
                .catch(function (err) {
                    console.log(err);
                    return err;
                });

        },
        filter() {
            let vm = this;
            vm.skip = 0;
            vm.take = 0;
            let datesArr = vm.search.dateRange.trim().split('to')
            if (datesArr.length > 1) {
                vm.search.fromDate = datesArr[0].trim();
                vm.search.toDate = datesArr[1].trim();
            }
            vm.getGuidelines()
                .then(function (res) {
                    vm.guidelines = res.data;
                })
                .catch(function (err) {
                    console.log(err);
                    return err;
                });
        },
        getGuidelines() {
            let vm = this;
            return axiosCommon.get(`o/guidelines?language=${vm.localeService.getCurrentLocale()}&skip=${vm.skip}&take=${vm.take}&fromDate=${vm.search.fromDate.toString()}&toDate=${vm.search.toDate}&keywords=${vm.search.keywords}`)
                .then(function (res) {
                    return res;
                })
                .catch(function (err) {
                    return err;
                });
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/guideline-dashboard/guideline-dashboard.js